import { render, staticRenderFns } from "./ShowPDF.vue?vue&type=template&id=21fe5f54&scoped=true"
import script from "./ShowPDF.vue?vue&type=script&lang=js"
export * from "./ShowPDF.vue?vue&type=script&lang=js"
import style0 from "./ShowPDF.vue?vue&type=style&index=0&id=21fe5f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe5f54",
  null
  
)

export default component.exports